import { useState } from "react";
import { api } from "../../../../../../../utility/api";
import { transformRecepcion } from "../../../helpers/data";

const transformRecepciones = (response) => {
    const { count, results } = response;

    const data = results.map((item) => transformRecepcion(item));

    return { count, results: data };
};

export const SeleccionRecepcionesApi = () => {
    const [cargando, setCargando] = useState(false);

    const getRecepcionesFinalizadas = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("traslado_movimientos/ingresos", params);
            return transformRecepciones(response);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const asignarRecepcionesTraslado = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                "traslado_movimientos/asignar-recepciones-traslado",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const syncRecepcionesTraslado = async (data) => {
        try {
            setCargando(true);
            const response = await api.post(
                "traslado_movimientos/sync-recepciones-materia-prima",
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getRecepcionesFinalizadas,
        asignarRecepcionesTraslado,
        syncRecepcionesTraslado,

        cargando,
    };
};
